var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "npv-configuration-container" },
    [
      _c("tabs", {
        attrs: { tabs: _vm.tabs, currentTab: _vm.currentTab },
        on: { "update-current-tab": _vm.updateCurrentTab }
      }),
      _vm._v(" "),
      _vm.currentTab === 0 ? _c("configuration-workspaces") : _vm._e(),
      _vm._v(" "),
      _vm.currentTab === 1 ? _c("configuration-buildings") : _vm._e(),
      _vm._v(" "),
      _vm.currentTab === 2 ? _c("configuration-forms") : _vm._e(),
      _vm._v(" "),
      _vm.currentTab === 3
        ? _c("configuration-preview", { on: { cancel: _vm.cancel } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a75efc0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a75efc0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Npv/Configuration/Npv.vue
// module id = null
// module chunks = 